<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="handleSave"
        hide-header
        persistent
        ref="RkmModal"
    >
        <Form
            :id="model.id"
            @saved="saved"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        model: {
            id: null,
        },
    }),
    methods: {
        open(id) {
            this.model.id = id
            this.$refs.RkmModal.show()
        },
        handleSave() {
            this.$refs.Form.save()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        saved() {
            this.handleExit()
            this.$emit('save')
        },
    },
}
</script>